var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetTempIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_2463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 13.3333V22.1166C22.302 22.4835 22.7986 23.0498 23.0794 23.7278C23.3602 24.4057 23.4095 25.1573 23.2196 25.8661C23.0297 26.5749 22.6112 27.2012 22.029 27.6479C21.4469 28.0946 20.7336 28.3367 19.9998 28.3367C19.2661 28.3367 18.5528 28.0946 17.9706 27.6479C17.3885 27.2012 16.97 26.5749 16.7801 25.8661C16.5902 25.1573 16.6394 24.4057 16.9202 23.7278C17.201 23.0498 17.6977 22.4835 18.3332 22.1166V13.3333C18.3332 12.8913 18.5088 12.4673 18.8213 12.1548C19.1339 11.8422 19.5578 11.6666 19.9998 11.6666C20.4419 11.6666 20.8658 11.8422 21.1783 12.1548C21.4909 12.4673 21.6665 12.8913 21.6665 13.3333Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_2463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetTempIcon);
export default __webpack_public_path__ + "static/media/set_temp_icon.0dafe93ccef3dd6988e4452093304944.svg";
export { ForwardRef as ReactComponent };